// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","optionList":"_2Ub-CwTjVsHCIWsXEwiAf-","optionInput":"_23hompDwekiVlEHijdGLTx"};